(function () {
  'use strict';

  const STORAGE_KEY = 'private_sale_validated';
  const APPLIED_KEY = 'private_sale_discount_applied';
  const BODY_CLASS = 'private-sale-validated';

  let toastTimer = null;

  function showToast(message) {
    const toast = document.getElementById('private-sale-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2000);
  }

  function isExpired(endDateStr) {
    if (!endDateStr) return false;
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}` > endDateStr;
  }

  // Apply a discount code to the cart by hitting Shopify's discount endpoint.
  // The fetch sets the discount cookie on the response; the browser stores it
  // because we send credentials. Fires at most once per session per code.
  function applyDiscount(code) {
    if (!code) return;
    if (sessionStorage.getItem(APPLIED_KEY) === code) return;
    sessionStorage.setItem(APPLIED_KEY, code);
    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
      cache: 'no-store'
    }).catch(function () {
      // If the request fails (offline, etc.), let it retry next session.
      sessionStorage.removeItem(APPLIED_KEY);
    });
  }

  class PrivateSaleValidator extends HTMLElement {
    connectedCallback() {
      const param = this.getAttribute('url-param') || '';
      const path = this.getAttribute('url-path') || '';
      const endDate = this.getAttribute('end-date') || '';

      // Kill switch: if expired, clear flag and bail.
      if (endDate && isExpired(endDate)) {
        localStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(APPLIED_KEY);
        return;
      }

      let unlockJustMatched = false;

      // Check if current URL matches the configured unlock URL.
      // Configured value may be a path ("/products/foo") or a full URL ("https://...").
      // Normalize both to pathname before comparing.
      if (path) {
        let target = path;
        try {
          if (/^https?:/i.test(path)) {
            target = new URL(path).pathname;
          }
        } catch (e) {}
        target = target.replace(/\/+$/, '');
        const here = window.location.pathname.replace(/\/+$/, '');
        if (here === target) {
          localStorage.setItem(STORAGE_KEY, '1');
          unlockJustMatched = true;
        }
      }

      // Check if current URL has the configured query param.
      if (param) {
        const eq = param.indexOf('=');
        const key = eq === -1 ? param : param.slice(0, eq);
        const expected = eq === -1 ? undefined : param.slice(eq + 1);
        if (key) {
          const value = new URL(window.location.href).searchParams.get(key);
          if (value !== null && (expected === undefined || value === expected)) {
            localStorage.setItem(STORAGE_KEY, '1');
            unlockJustMatched = true;
          }
        }
      }

      // When the visitor hits the unlock URL or param again, reset the session
      // throttle so the next applyDiscount call fires even if it already fired
      // earlier in the same session. Lets returning newsletter clicks always
      // re-apply the discount.
      if (unlockJustMatched) {
        sessionStorage.removeItem(APPLIED_KEY);
      }

      // Apply body class and auto-apply discount if validated.
      if (localStorage.getItem(STORAGE_KEY) === '1') {
        document.body.classList.add(BODY_CLASS);

        // Auto-apply the first available discount code on the page (PDP/collection card).
        const codeButton = document.querySelector('[data-private-sale-copy-code]');
        if (codeButton) {
          const code = codeButton.getAttribute('data-code');
          if (code) applyDiscount(code);
        }
      }
    }
  }

  customElements.define('private-sale-validator', PrivateSaleValidator);

  // Copy-to-clipboard for any [data-private-sale-copy-code]. The element's data-code
  // attribute holds the value to copy. Shows a toast, also applies the discount.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-private-sale-copy-code]');
    if (!button) return;
    const code = button.getAttribute('data-code') || '';
    if (!code) return;
    event.preventDefault();

    const toastMessage = button.getAttribute('data-toast-message')
      || (document.documentElement.lang && document.documentElement.lang.startsWith('de') ? 'Code kopiert' : 'Code copied');

    const reveal = function () {
      button.classList.add('copied');
      showToast(toastMessage);
      applyDiscount(code);
      setTimeout(function () { button.classList.remove('copied'); }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(reveal).catch(reveal);
    } else {
      reveal();
    }
  });
})();
